import { ThemeConfig } from "antd";
import { defaultTheme } from "./defaultTheme";
import { paveTheme } from "./paveTheme";
import { dyveTheme } from "./dyveTheme";
import { merge } from "lodash";
import { docnodesTheme } from "./docnodesTheme";

export function getThemeConfig(theme: API_LOGINSETTINGS_THEME): ThemeConfig {
  const config: ThemeConfig = {
    cssVar: { key: "app" },
    hashed: true,
    token: {
      controlHeight: 40,
      borderRadius: 4,
      fontFamily: '"Roboto", sans-serif',
      fontSize: 15,
      colorInfo: "#24b3a7",
      colorTextDisabled: "rgba(0, 0, 0, 0.55)",
    },
    components: {
      Dropdown: {
        paddingBlock: 4,
      },
      Layout: {
        headerHeight: 80,
        headerPadding: 0,
        bodyBg: "#fff",
        siderBg: "#212325",
      },
      Progress: {
        defaultColor: "#24b3a7",
      },
      Badge: {
        // colorError: "#24b3a7",
        // colorErrorHover: "#24b3a7",
      },
      Tabs: { colorPrimary: "#003d58", colorPrimaryHover: "#003d58" },
      Select: {
        borderRadius: 4,
      },
      Menu: {
        itemBorderRadius: 0,
      },
      Modal: {
        titleFontSize: 26,
      },
      Card: {
        fontWeightStrong: 500,
      },
      Table: {
        padding: 10,
        headerBg: "#fff",
        headerColor: "#8992a1",
        fontWeightStrong: 500,
        rowHoverBg: "#ccfbf9",
        bodySortBg: "#fff",
        headerSortActiveBg: "#fff",
      },
      Message: {
        zIndexPopupBase: 9999,
        zIndexBase: 9999,
      },
    },
  };
  switch (theme) {
    case "PAVE":
      merge(config, paveTheme);
      break;
    case "DYVE":
      merge(config, dyveTheme);
      break;
    case "DOCNODES":
      merge(config, docnodesTheme);
      break;
    case "DEFAULT":
    default:
      merge(config, defaultTheme);
      break;
  }
  return config;
}
